import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from "reactstrap";
import { toast } from "react-toastify";
import axiosInstance from "../../helpers/axiosInstance";

// PLACEHOLDER - Replace with your actual Breadcrumbs component
const Breadcrumbs = ({ title, breadcrumbItems }) => (
  <div>
    <h3>{title}</h3>
    <ul>
      {breadcrumbItems.map((item) => (
        <li key={item.title}> {item.title} </li>
      ))}
    </ul>
  </div>
);

const Notification = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [notificationData, setNotificationData] = useState({
    title: "",
    body: "",
    data: {
      type: "announcement",
      actionUrl: "/promotions"
    }
  });

  const breadcrumbItems = [
    { title: "Toy Hub Admin", link: "/" },
    { title: "Send Notification", link: "#" },
  ];

  const handleSendNotification = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    
    try {
      await axiosInstance.post("/api/v1/admin/notifications/all", notificationData);
      toast.success("Notification sent successfully!");
      setSuccess(true);
      
      // Reset form
      setNotificationData({
        title: "",
        body: "",
        data: {
          type: "announcement",
          actionUrl: ""
        }
      });
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.success("Notification sent successfully!");
    } finally {
      setLoading(false);
    }
  };

  const handleTypeChange = (e) => {
    setNotificationData({
      ...notificationData,
      data: {
        ...notificationData.data,
        type: e.target.value
      }
    });
  };

  const handleActionUrlChange = (e) => {
    setNotificationData({
      ...notificationData,
      data: {
        ...notificationData.data,
        actionUrl: e.target.value
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Send Notification" breadcrumbItems={breadcrumbItems} />
          <Row className="justify-content-center">
            <Col lg={8}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Send Push Notification</h4>
                  
                  {success && (
                    <Alert color="success" className="mb-4">
                      Notification sent successfully to all users!
                    </Alert>
                  )}
                  
                  <Form onSubmit={handleSendNotification}>
                    <FormGroup>
                      <Label for="title">Notification Title</Label>
                      <Input
                        type="text"
                        id="title"
                        name="title"
                        value={notificationData.title}
                        onChange={(e) =>
                          setNotificationData({ ...notificationData, title: e.target.value })
                        }
                        placeholder="Enter notification title"
                        required
                      />
                    </FormGroup>
                    
                    <FormGroup>
                      <Label for="body">Notification Message</Label>
                      <Input
                        type="textarea"
                        id="body"
                        name="body"
                        value={notificationData.body}
                        onChange={(e) =>
                          setNotificationData({ ...notificationData, body: e.target.value })
                        }
                        placeholder="Enter notification message"
                        required
                        rows="4"
                      />
                    </FormGroup>
                    
                    {/* <FormGroup>
                      <Label for="type">Notification Type</Label>
                      <Input
                        type="select"
                        id="type"
                        name="type"
                        value={notificationData.data.type}
                        onChange={handleTypeChange}
                      >
                        <option value="announcement">Announcement</option>
                        <option value="promotion">Promotion</option>
                        <option value="update">App Update</option>
                        <option value="alert">Alert</option>
                      </Input>
                    </FormGroup> */}
                    
                    {/* <FormGroup>
                      <Label for="actionUrl">Action URL (optional)</Label>
                      <Input
                        type="text"
                        id="actionUrl"
                        name="actionUrl"
                        value={notificationData.data.actionUrl}
                        onChange={handleActionUrlChange}
                        placeholder="e.g., /promotions"
                      />
                      <small className="form-text text-muted">
                        Specify where users should be directed when they tap the notification
                      </small>
                    </FormGroup> */}
                    
                    <div className="text-center mt-4">
                      <Button 
                        type="submit" 
                        color="primary" 
                        size="lg" 
                        disabled={loading}
                        className="px-5"
                      >
                        {loading ? "Sending..." : "Send Notification"}
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Notification;